import { AnswerType } from "modules/NewClientSurvey/common/constants"
import { checkIsInput } from "modules/NewClientSurvey/common/utils/checkIsInput"

export function showNextButton(type: AnswerType, required: boolean): boolean {
    return (
        checkIsInput(type) ||
        type === AnswerType.choices ||
        (type === AnswerType.yes_no && !required) ||
        (type === AnswerType.choice && !required)
    )
}
